import React, { useState, useEffect, useMemo } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";
import countryCodes from "../../Common/CountryCodes";

// Static value map for results per page
const RESULTS_PER_PAGE_MAP = { 25: 25, 50: 50, 100: 100, 200: 200 };

const ResellerUserForm = props => {
  const [formFields, setFormFields] = useState();
  const [resellers, setResellers] = useState();

  // Memoize country code map to prevent recreation on every render
  const countryCodeMap = useMemo(() => {
    const codeMap = {};
    
    Object.keys(countryCodes).forEach(function(c) {
      if (!codeMap[countryCodes[c].code]) {
        codeMap[countryCodes[c].code] = countryCodes[c].name;
      } else {
        codeMap[countryCodes[c].code] =
          codeMap[countryCodes[c].code] + " / " + countryCodes[c].name;
      }
    });

    Object.entries(codeMap).forEach(([key, value]) => {
      codeMap[key] = value + " (" + key + ")";
    });

    return codeMap;
  }, []);

  // Memoize default object
  const defaultObject = useMemo(() => ({
    is_reseller_admin: false
  }), []);

  useEffect(() => {
    http.Get(
      'resellers',
      (data) => {
        const resellerMap = {};
        data.forEach((reseller) => {
          resellerMap[reseller.id] = reseller.name;
        });
        setResellers(resellerMap);
      },
      () => {
        console.error("Failed to fetch resellers");
      }
    );
  }, []);

  // Memoize form fields configuration
  const memoizedFormFields = useMemo(() => {
    if (!resellers) {
      return null;
    }

    return [
      {
        id: "reseller",
        label: "RESELLER",
        type: "select",
        valueMap: resellers
      },
      {
        id: "first_name",
        label: "FIRST NAME *",
        type: "text"
      },
      {
        id: "last_name",
        label: "LAST NAME *",
        type: "text"
      },
      {
        id: "email",
        label: "EMAIL *",
        type: "email"
      },
      {
        id: "phone",
        label: "PHONE",
        type: "text"
      },
      {
        id: "mobile",
        label: "MOBILE",
        type: "text"
      },
      {
        id: "country_code",
        label: "COUNTRY CODE",
        type: "select",
        valueMap: countryCodeMap
      },
      {
        id: "number_of_result_per_page",
        label: "NUMBER OF RESULT PER PAGE *",
        type: "select",
        valueMap: RESULTS_PER_PAGE_MAP
      },
      {
        id: "is_reseller_admin",
        label: "IS RESELLER ADMIN",
        type: "radio"
      },
      {
        id: "has_access",
        label: "HAS ACCESS",
        type: "radio"
      },
    ];
  }, [resellers, countryCodeMap]);

  useEffect(() => {
    setFormFields(memoizedFormFields);
  }, [memoizedFormFields]);

  return (
    <div>
      {formFields && (
        <ObjectForm
          {...props}
          url={`reseller_users`}
          formName={"Reseller User"}
          formFields={formFields}
          object={defaultObject}
        />
      )}
    </div>
  );
};

export default ResellerUserForm;